// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { ImageryResolution, VideoResolution, UploadFormat } from '../../constants/setting'

export interface IUploadQualityCellProps {
  uploadFmt: UploadFormat
  imageryResolution: ImageryResolution
  videoResolution: VideoResolution
}
export function UploadQualityCell (props: IUploadQualityCellProps) {
  let text = ''
  if (props.uploadFmt === UploadFormat.Images) {
    switch (props.imageryResolution) {
      case ImageryResolution._8_MP:
        text = '8MP'
        break
      case ImageryResolution._2_MP:
        text = '2MP'
        break
      case ImageryResolution._5_MP:
        text = '5MP'
        break
      case ImageryResolution._12_MP:
        text = '12MP'
        break
      default:
        break
    }
  } else if (props.uploadFmt === UploadFormat.Video) {
    switch (props.videoResolution) {
      case VideoResolution._720:
        text = '720p'
        break
      case VideoResolution._1080:
        text = '1080p'
        break
      case VideoResolution._2700:
        text = '2.7k'
        break
      case VideoResolution._4000:
        text = '4k'
        break
      default:
        break
    }
  }
  return <span>{text}</span>
}
